{
  "info": "Інформація",
  "negative": "Помилка",
  "notice": "Попередження",
  "positive": "Успішно"
}
